<template>
  <div id="app">
    <el-button
      style="margin-bottom: 20px"
      @click="addType(0)"
      size="small"
      type="primary"
      >添加类型</el-button
    >
    <!-- 表格区域 -->
    <el-table
      :data="typeList"
      style="width: 100%; margin-bottom: 20px"
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      row-key="id"
      border
      stripe
      default-expand-all
      :tree-props="{ children: 'childList', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" prop="typeName" label="资讯类型">
      </el-table-column>
      <el-table-column align="center" label="展示方式">
        <template slot-scope="scope">
          <span>
            {{ scope.row.displayType == 1 ? "普通文章" : "图文" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="公开设置">
        <template slot-scope="scope">
          <el-switch
            @change="isOpenFlag(scope.row)"
            v-model="scope.row.isOpen"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="typeSort"
        width="120"
        label="排序"
        sortable
      >
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.isLeaf == 0">
            <el-button type="text" @click="editorType(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" @click="addType(1, scope.row.id)"
              >添加子类</el-button
            >
            <el-button style="color:#ff5151" type="text" @click="deleteType(scope.row)"
              >删除</el-button
            >
          </div>
          <div v-else>
            <el-button type="text" @click="editorType(scope.row)"
              >编辑</el-button
            >
            <el-button style="color:#ff5151" type="text" @click="deleteType(scope.row, 1)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :before-close="handleClose"
      width="550px"
      :title="title"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="ruleForm" ref="types">
        <el-form-item
          prop="typeName"
          :rules="[
            { required: true, message: '请输入资讯名称', trigger: 'blur' },
          ]"
          label="资讯名称"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            style="width: 300px"
            v-model="ruleForm.typeName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="typeSort"
          label="排序："
          :label-width="formLabelWidth"
          :rules="[
            { required: true, message: '序号不能为空' },
            { type: 'number', message: '序号必须为数字值' },
          ]"
        >
          <el-input
            size="small"
            style="width: 300px"
            v-model.number="ruleForm.typeSort"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="typeFlag"
          label="展示方式："
          :label-width="formLabelWidth"
        >
          <el-switch
            v-model="ruleForm.typeFlag"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="图文"
            inactive-text="普通文章"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="是否公开：" :label-width="formLabelWidth">
          <el-switch v-model="ruleForm.isOpen"> </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="baocunType"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as homeApi from "@/api/home";
import { ERR_OK } from "@/api/index";
export default {
  data() {
    return {
      title: "添加资讯类型",
      // groupId: 5,
      groupId: localStorage.getItem("groupId"),
      dialogFormVisible: false,
      parentId: 0,
      ruleForm: {
        typeName: "",
        typeSort: "",
        typeFlag: false,
        isOpen: true,
      },
      id: -1,
      typeList: [],
      formLabelWidth: "120px",
      isLeaf: 0,
      flag: 0,
    };
  },
  created() {
    this.queryTypeList();
  },
  methods: {
    //   保存类型
    addType(flag, pId = 0) {
      this.dialogFormVisible = true;
      this.flag = flag;
      this.parentId = pId;
    },
    // 保存
    baocunType() {
      this.$refs.types.validate((valid) => {
        if (valid) {
          console.log("this.parentId", this.parentId);
          let params = {
            typeName: this.ruleForm.typeName,
            groupId: this.groupId,
            isLeaf: this.isLeaf,
            parentId: this.parentId,
            displayType: 1,
            isOpen: 1,
            typeSort: this.ruleForm.typeSort,
          };
          if (this.flag == 1) {
            params.isLeaf = 1;
            params.parentId = this.parentId;
          }
          if (this.ruleForm.typeFlag) {
            params.displayType = 2;
          }
          if (!this.ruleForm.isOpen) {
            params.isOpen = 0;
          }
          if (this.id !== -1) {
            params.id = this.id;
          }
          homeApi.saveArticleType(params).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: "保存成功",
              });
            }
            this.dialogFormVisible = false;
            this.queryTypeList();
            this.clear();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 资讯类型查询
    queryTypeList() {
      let params = {
        groupId: this.groupId,
      };
      homeApi.queryTypeList(params).then((res) => {
        let datas = res.data.data;
        datas.forEach((item) => {
          if (item.isOpen == 1) {
            item.isOpen = true;
          } else {
            item.isOpen = false;
          }
          if (item.childList !== null) {
            item.childList.forEach((items) => {
              if (items.isOpen == 1) {
                items.isOpen = true;
              } else {
                items.isOpen = false;
              }
            });
          }
        });
        this.typeList = datas;
      });
    },
    // 公开设置
    isOpenFlag(row) {
      let rows = row;
      delete row.childList;
      if (rows.isOpen) {
        rows.isOpen = 1;
      } else {
        rows.isOpen = 0;
      }
      homeApi.saveArticleType(rows).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            type: "success",
            message: "操作成功",
          });
        }
        this.queryTypeList();
      });
    },
    // 编辑
    editorType(row) {
      let rows = row;
      delete row.childList;
      this.ruleForm.typeName = rows.typeName;
      this.ruleForm.typeSort = rows.typeSort;
      this.isLeaf = rows.isLeaf;
      this.parentId = rows.parentId;
      this.id = rows.id;
      this.ruleForm.typeFlag = true;
      if (rows.displayType == 1) {
        this.ruleForm.typeFlag = false;
      }
      this.ruleForm.isOpen = false;
      if (rows.isOpen == 1) {
        this.ruleForm.isOpen = true;
      }
      this.dialogFormVisible = true;
    },
    // 数据清除
    clear() {
      this.ruleForm.typeName = "";
      this.ruleForm.typeSort = "";
      this.ruleForm.typeFlag = false;
      this.ruleForm.isOpen = true;
      this.isLeaf = 0;
      this.parentId = 0;
      this.id = -1;
      this.$refs.types.resetFields();
    },
    // diog关闭
    handleClose() {
      this.dialogFormVisible = false;
      this.clear();
    },
    // 删除
    deleteType(row, flag) {
      if (flag !== 1) {
        if (row.childList !== null) {
          this.$message.error("该项下有子项，请先删除子项后重试！");
          return false;
        }
      }
      homeApi
        .deleteType({
          id: row.id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
          }
          this.queryTypeList();
        });
    },
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/informa/setup.vue